<mat-card>
  <mat-card-title class="flex flex-row justify-between items-center">
    <span>{{ '+INSTALLATIONS.INSTALLATION.HEMS.LITE.HELP.TITLE' | translate }}</span>
    <button
      mat-icon-button
      mat-dialog-close
      gtm="onClose"
      gtmAction="closeDialog"
      class="close-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-title>

  <mat-card-content class="flex flex-col gap-[16px]">
    <p>{{ '+INSTALLATIONS.INSTALLATION.HEMS.LITE.HELP.DESCRIPTION' | translate }}</p>

    <app-banner
      type="info"
      [title]="'+INSTALLATIONS.INSTALLATION.HEMS.LITE.HELP.NOTE.TITLE' | translate"
    >
      {{ '+INSTALLATIONS.INSTALLATION.HEMS.LITE.HELP.NOTE.DESCRIPTION' | translate }}
    </app-banner>
  </mat-card-content>

  <mat-card-actions class="!flex flex-row justify-end items-center">
    <button
      mat-raised-button
      mat-dialog-close
      color="primary"
      gtm="onClose"
      gtmAction="HEMS Lite info dialog"
      gtmCategory="hems"
    >
      {{ 'GENERAL.BUTTON.CLOSE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
